// Onglets de la vue Demandes — logique pure, AUCUNE dépendance Supabase/React.
// 3 onglets demandés par le cabinet : Prospects (vraies demandes juridiques),
// Candidatures (stages/emploi), Autre (difficile à classer). Les clés
// `clientele` / `recrutement` et les slugs de catégorie ne changent pas.
// La classification dérive de la catégorie existante : aucune table en plus.
import type { Tables } from '../../types/database.types';

export type TicketTab = 'clientele' | 'recrutement' | 'autre';

export const TICKET_TAB_LABELS: Record<TicketTab, string> = {
  clientele: 'Prospects',
  recrutement: 'Candidatures',
  autre: 'Autre',
};

export const TICKET_TABS: TicketTab[] = ['clientele', 'recrutement', 'autre'];

/** Slug de la catégorie recrutement (cf. migration add_recrutement_category). */
export const RECRUITMENT_CATEGORY_SLUG = 'recrutement';

/**
 * Range un ticket dans l'un des 3 onglets, à partir de sa catégorie :
 * - slug `recrutement`         → Recrutement
 * - catégorie avec un `pole`   → Clientèle (les 12 catégories juridiques)
 * - tout le reste (slug `autre`, catégorie sans pôle, ou aucune catégorie)
 *                              → Autre
 * Fonction pure (testable sans DB).
 */
export function classifyTicketTab(
  category: Pick<Tables<'ticket_categories'>, 'slug' | 'pole'> | null | undefined,
): TicketTab {
  if (!category) return 'autre';
  if (category.slug === RECRUITMENT_CATEGORY_SLUG) return 'recrutement';
  if (category.pole) return 'clientele';
  return 'autre';
}
